<template>
    <div>
        <div v-if="mode == 'edit'" class="rich-text-container">
            <RichText v-model="content" :options="optionsRichText" class="custom-richtext" />
        </div>
        <div v-else class="rich-text-style" v-html="addBrToEmptyParagraphs(content)" />
    </div>
</template>

<script>
import RichText from 'vcomponents/richtext/RichText.vue';
import CfMixin from 'mixins/CustomfieldInputsMixins';

export default {
    components: {
        RichText,
    },
    mixins: [CfMixin],
    emits: ['update:modelValue'],

    data() {
        return {
            content: this.prop.defaultValue,
            localValue: this.value,
            optionsRichText: [
                'Bold',
                'Italic',
                'Underline',
                'Strike',
                'BulletList',
                'OrderedList',
                'Divider',
                'Link',
                'Separator',
            ],
        };
    },
    watch: {
        content(newValue) {
            this.content = newValue;
            this.localValue.textValue = this.content;
            this.$emit('update:modelValue', this.localValue);
        },
        value(newValue) {
            this.localValue = newValue;
            this.content = this.localValue.textValue;
        },
    },
    mounted() {
        if (!this.localValue) {
            this.localValue = JSON.parse(JSON.stringify(this.templateData));
            this.$emit('update:modelValue', {
                ...this.localValue,
                ['textValue']: this.prop.defaultValue,
            });
        } else {
            this.content = this.value.textValue;
        }
    },
    methods: {
        addBrToEmptyParagraphs(html) {
            return html.replace(/<p[^>]*><\/p>/g, '<p><br class="ProseMirror-trailingBreak"></p>');
        },
    },
};
</script>

<style lang="scss" scoped>
.custom-richtext {
    width: 100%;
}
</style>
